// src/data/audioIndex.js
// Índice de audios del Placement Test — /public/audios/

const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
const SUBDIVISIONS = [1, 2, 3];

export const AUDIO_INDEX = CEFR_LEVELS.flatMap(level =>
  SUBDIVISIONS.map(sub => ({
    id: `${level}.${sub}`,
    level,
    subdivision: sub,
    url: `/audios/${level}.${sub}.mp3`,
    label: `${level} — Parte ${sub}`,
  }))
);

// Acceso directo por id: AUDIO_MAP['A1.1'] → { id, level, url... }
export const AUDIO_MAP = Object.fromEntries(
  AUDIO_INDEX.map(entry => [entry.id, entry])
);
